enum PROVIDER_NAME {
  YELP = 'YELP',
  GLX = 'GLX',
  GYG = 'GYG',
}

export default PROVIDER_NAME;
